const Repurchase = [
  // 复购
  {
      path: '/repurchase',
      name: 'repurchase',
      component: () => import('../views/repurchase/index.vue'),
      meta: {
          'title': 'Loan Payment'
      }
  },
  {
      path: '/repaymentNote',
      name: 'repaymentNote',
      component: () => import('../views/repurchase/repaymentNote.vue'),
      meta: {
          'title': 'Repayment Note'
      }
  },
  {
    path: '/repurchase/result',
    name: 'repurchase',
    component: () => import('../views/repurchase/result.vue'),
    meta: {
        'title': 'Loan Payment'
    }
  },
  {
      path: '/discountsAct',
      name: 'discountsAct',
      component: () => import('../views/newDesign/discountsActivity.vue'),
      meta: {
          'title': 'OKash'
      }
  }
]

export default Repurchase



// WEBPACK FOOTER //
// ./src/router/repurchase.js